// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3VgMt","title":"Info_title__3MAUy","links":"Info_links__16fdw","link":"Info_link__i_DtV","logo":"Info_logo__13d7V"};